import { useState, useEffect } from "react";
import UtilityVehicle from "./UtilityVehicle";
import { useDispatch, useSelector } from 'react-redux';
import RequisitionAction from '../../../../../../../Store/Component/Requisition/RequisitionAction'

const UtilityVehicleContainer = (props?: any) => {
  const managedEquipRef = props?.managedEquipRef;
  const dispatch = useDispatch();

  const [manufacturerDropDownList, setManufacturerDropDownList] = useState<any>([]);
  const [seatingCapacityDropDownList, setSeatingCapacityDropDownList] = useState<any>([]);
  const [enclosedCabDropDownList, setEnclosedCabDropDownList] = useState<any>([]);
  const [capacityDropDownList, setCapacityDropDownList] = useState<any>([]);

  const { managedEquipmentDropDown, managedEquipmentValues, editRequestDetails, isEditRequestClick }: any = useSelector((state? : any) => ({
    managedEquipmentDropDown: state.ManagedEquipmentDropDownReducer.managedEquipmentDropDown,
    managedEquipmentValues: state.RequisitionReducer.managedEquipmentValues,
    editRequestDetails: state.RequisitionReducer.editRequestDetails,
    isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
  }));

  ///Modified dropDown values as required
  useEffect(()=>{
    if (managedEquipmentDropDown?.length > 0) {
      managedEquipmentDropDown?.map((item: any) => {
        if (item?.dropdownName == "Manufacturer") {
          const defaultManufacturerOption = {
            text: "Select Manufacturer",
            value: null
        };
        item?.dropdownList?.unshift(defaultManufacturerOption);
          let manufacturerDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setManufacturerDropDownList(manufacturerDropdownListTemp)
        } else if (item?.dropdownName == "Seating Capacity") {
          const defaultSeatingCapacityOption = {
            text: "Select Seating Capacity",
            value: null
        };
        item?.dropdownList?.unshift(defaultSeatingCapacityOption);
        let seatingCapacityDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setSeatingCapacityDropDownList(seatingCapacityDropdownListTemp)
        }else if (item?.dropdownName == "Enclosed Cab") {
          const defaultEnclosedCabOption = {
            text: "Select Enclosed Cab",
            value: null
        };
        item?.dropdownList?.unshift(defaultEnclosedCabOption);
        let enclosedCabDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setEnclosedCabDropDownList(enclosedCabDropdownListTemp)
        }else if (item?.dropdownName == "Capacity") {
          const defaultCapacityOption = {
            text: "Select Capacity",
            value: null
        };
        item?.dropdownList?.unshift(defaultCapacityOption);
        let capacityDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setCapacityDropDownList(capacityDropdownListTemp)
        }
      })
    }
  },[managedEquipmentDropDown])

  useEffect(()=> {
    if (isEditRequestClick) {
      let managedEquipmentValuesTemp: any = {}
      let selectedManufacturer: any = ""
      let selectedSeatingCapacity: any = ""
      let selectedEnclosedCab: any = ""
      let selectedCapacity: any = ""
      
      if (editRequestDetails?.manufacturer && manufacturerDropDownList?.length > 0) {
        selectedManufacturer = manufacturerDropDownList?.find((option: any) => option?.value === editRequestDetails?.manufacturer)
      }

      if (editRequestDetails?.seatingCapacity && seatingCapacityDropDownList?.length > 0) {
        selectedSeatingCapacity = seatingCapacityDropDownList?.find((option: any) => option?.value === editRequestDetails?.seatingCapacity)
      }

      if (editRequestDetails?.enclosedCab && enclosedCabDropDownList?.length > 0) {
        selectedEnclosedCab = enclosedCabDropDownList?.find((option: any) => option?.value === editRequestDetails?.enclosedCab)
      }

      if (editRequestDetails?.capacity && capacityDropDownList?.length > 0) {
        selectedCapacity = capacityDropDownList?.find((option: any) => option?.value === editRequestDetails?.capacity)
      }

      managedEquipmentValuesTemp = { 
        ...managedEquipmentValues, 
        manufacturer: selectedManufacturer, 
        seatingCapacity: selectedSeatingCapacity,
        enclosedCab: selectedEnclosedCab,
        capacity: selectedCapacity,
      }
      dispatch(RequisitionAction.setManagedEquipmentValues(managedEquipmentValuesTemp))
    }
  }, [isEditRequestClick, manufacturerDropDownList, seatingCapacityDropDownList, enclosedCabDropDownList, capacityDropDownList])

useEffect(()=> {
  managedEquipRef.current[1]?.focus()
},[])

const handleSeatingCapacityChange = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item.label !== 'Select Seating Capacity') {
    managedEquipRef.current[2]?.focus()
  }
}

const handleManufacturerChange = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item.label !== 'Select Manufacturer') {
    managedEquipRef.current[3]?.focus()
  }
}

const handleEnclosedCabChange = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item.label !== 'Select Enclosed Cab') {
    managedEquipRef.current[4]?.focus()
  }
}

const handleCapacityChange = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item.label !== 'Select Capacity') {
    managedEquipRef.current[8]?.focus()
  }
}

  return (
    <UtilityVehicle
        managedEquipmentValues={managedEquipmentValues}
        seatingCapacityDropDownList={seatingCapacityDropDownList}
        manufacturerDropDownList={manufacturerDropDownList}
        enclosedCabDropDownList={enclosedCabDropDownList}
        capacityDropDownList={capacityDropDownList}
        managedEquipRef={managedEquipRef}
        handleSeatingCapacityChange={handleSeatingCapacityChange}
        handleManufacturerChange={handleManufacturerChange}
        handleEnclosedCabChange={handleEnclosedCabChange}
        handleCapacityChange={handleCapacityChange}
    />
  )
}

export default UtilityVehicleContainer;
